import React from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import { FadeInWrapper } from './index.style'
import { useStore } from '@Store/'
import { animation } from '@styles/vars/animation.style'

const AnimateFadeIn = ({
  delay = 0,
  triggerOnce = true,
  animate = true,
  children,
}) => {
  const [ref, inView] = useInView({
    triggerOnce,
    rootMargin: animation.rootMargin,
  })
  const [store] = useStore()
  const { showIntroMask, showPageMask } = store

  return (
    <FadeInWrapper
      ref={ref}
      inView={inView && animate && !showIntroMask && !showPageMask}
      delay={delay}
    >
      {children}
    </FadeInWrapper>
  )
}

AnimateFadeIn.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number,
  triggerOnce: PropTypes.bool,
  animate: PropTypes.bool,
}

export default AnimateFadeIn
